import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * ScrollToTop Component
 * Rola a página para o topo sempre que a rota muda.
 * Deve ser usado dentro do BrowserRouter.
 */
const ScrollToTop = () => {
    const { pathname } = useLocation();

    useEffect(() => {
        // Scroll suave para o topo da página
        window.scrollTo({
            top: 0,
            left: 0,
            behavior: 'instant' // 'instant' para transição imediata, 'smooth' para suave
        });
    }, [pathname]);

    return null;
};

export default ScrollToTop;
